import { styled, keyframes } from 'styled-components';

import { Section } from '@/js/libs/ui/src/V2';

const ANIMATION_DURATION_MS = 200;

const overlayShow = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const overlayHide = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(10px);
  }
`;

export const ToggleButton = styled.button<{ $isActive: boolean }>`
  position: fixed;
  bottom: 40px;
  right: 48px;
  z-index: 999;
  width: 48px;
  height: 48px;
  padding: 8px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $isActive, theme }) => ($isActive ? theme.colors.mainDark : theme.colors.main)};
  color: ${({ theme }) => theme.colors.grey00_1};
  ${({ theme }) => theme.shadows.medium};
  transition:
    transform 0.2s,
    background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.colors.mainDark};
  }
`;

export const OverlayContainer = styled.div<{ $visible: boolean }>`
  position: fixed;
  bottom: 112px;
  right: 24px;
  z-index: 9000;
  width: 600px;
  height: 100%;
  max-height: calc(100vh - 136px);
  background: ${({ theme }) => theme.colors.grey00_1};
  border-radius: ${({ theme }) => theme.borders.radiusMedium}px;
  ${({ theme }) => theme.shadows.large};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: ${({ $visible }) => ($visible ? overlayShow : overlayHide)} ${ANIMATION_DURATION_MS}ms ease forwards;
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
`;

export const SectionContainer = styled(Section)`
  flex: 1;
`;

export const SearchContainer = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
  background: ${({ theme }) => theme.colors.grey00_1};
`;

export const TranslationList = styled.div`
  flex: 1;
  overflow-y: auto;
  background: ${({ theme }) => theme.colors.grey00_1};
`;

export const TranslationItem = styled.div`
  padding: 24px;
  cursor: pointer;
  transition: background-color 0.15s;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
  background: ${({ theme }) => theme.colors.grey00_1};
  display: flex;
  flex-direction: column;
  gap: 8px;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.grey01_1};
  }
`;

export const TranslationMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const TranslationMetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  ${({ theme }) => theme.typography.textMedium};
`;

export const TranslationMetaLabel = styled.span`
  color: ${({ theme }) => theme.colors.grey100_1};
`;

export const TranslationMetaValue = styled.span`
  color: ${({ theme }) => theme.colors.black_1};
`;

export const TranslationValue = styled.div`
  ${({ theme }) => theme.typography.textMedium};
  color: ${({ theme }) => theme.colors.black_1};
`;

export const EmptyState = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey100_1};
  ${({ theme }) => theme.typography.textMedium};
  background: ${({ theme }) => theme.colors.grey00_1};
`;

export const ToggleIcon = styled.span`
  font-size: 24px;
`;
